
import { updatePromoCodeData } from "../../../../actions/siteadmin/PromoCode/managePromoCodeData";

async function submit(values, dispatch) {
    await dispatch(updatePromoCodeData(values));
}

export default submit;